<template>
    <div v-if="jsonString!=null" class="json-render-container">
        <div class="json-title" v-if="titleField!=null">
            {{title}}
        </div>
        <div class="json-content">
            {{jsonString}}
        </div>
    </div>
</template>
<style scoped>
.json-render-container {
    padding: 10px;
    border: 1px solid #e1e1e1;
    border-radius: 4px;
    background-color: #f9f9f9;
    margin-bottom: 10px;
}
.json-title {
    font-weight: bold;
    color: #337ab7;
    font-size: 16px;
    margin-bottom: 8px;
    padding-bottom: 5px;
    border-bottom: 1px solid #ddd;
}
.json-content {
    word-wrap: break-word;
    white-space: pre-wrap;
    background-color: #fff;
    padding: 10px;
    border-radius: 3px;
    border: 1px solid #ddd;
    font-family: monospace;
    font-size: 13px;
    color: #333;
}
</style>

<script>
    export default {
        props: {
            jsonString: { type: String, default: null },
            titleField: { type: String, default: null }
        },
        computed: {
            item: function () {
                if (this.jsonString === null) return null;
                return JSON.parse(this.jsonString);
            },
            title: function () {
                if (this.item === null || this.titleField === null) return null;
                return this.item[this.titleField];
            }
        }
    }
</script>